/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type change_requests_ChangeRequestSourceDTO = {
    kind: change_requests_ChangeRequestSourceDTO.kind;
    /**
     * shared by every request decomposed from one source
     */
    message_id?: string;
    raw_excerpt?: string;
};
export namespace change_requests_ChangeRequestSourceDTO {
    export enum kind {
        WEB_ADMIN = 'web_admin',
        EMAIL = 'email',
        APP = 'app',
    }
}

